import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'journalLabel',
    standalone: false
})
export class JournalLabelPipe implements PipeTransform {

    static format(journal: Record<string, any>, codeName = 'Code', labelName = 'Libelle'): string {
        return [codeName, labelName].map(property => journal?.[property]).filter(e => !!e).join(' - ');
    }

    transform(journal: Record<string, any>, codeName = 'Code', labelName = 'Libelle'): string {
        return JournalLabelPipe.format(journal, codeName, labelName);
    }
}
